export default "__VITE_ASSET__CqYL1GdP__"